<template>
  <el-dialog
    :visible.sync="currentlyVisible"
    :before-close="handleCancel"
    title="Exported respondents"
  >
    <el-table :data="surveyExports">
      <el-table-column label="Created" width="150">
        <template slot-scope="scope">{{ scope.row.insertedAt | moment('LL HH:mm') }}</template>
      </el-table-column>
      <el-table-column label="User" width="200">
        <template slot-scope="scope">{{
          `${scope.row.user.firstName} ${scope.row.user.lastName}`
        }}</template>
      </el-table-column>
      <el-table-column label="Export type">
        <template slot-scope="scope">
          <div v-if="scope.row.survey">
            <div class="title">Survey</div>
            <div>{{ scope.row.survey.title }}</div>
          </div>
          <div v-else>
            <div class="title">Period</div>
            <div>
              {{ title(scope.row.periodType) }}
              <span v-if="scope.row.periodType !== 'LIFETIME'"
                >from {{ scope.row.periodDate | moment('Do MMM YYYY') }}</span
              >
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="60">
        <template slot-scope="scope">
          <span class="text-right">
            <a :href="scope.row.fileUrl">
              <i class="fa fa-fw fa-download"></i>
            </a>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import gql from 'graphql-tag';
import moment from 'moment';

const fragments = gql`
  fragment surveyExportFragment on SurveyExport {
    id
    fileUrl
    periodDate
    periodType
    insertedAt
    survey {
      id
      title
    }
    user {
      id
      firstName
      lastName
    }
  }
`;

export default {
  name: 'ExportedSurveyRespondentList',
  data: () => ({
    moment,
  }),
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  apollo: {
    $client: 'apiv2',
    surveyExports: {
      query: gql`
        {
          surveyExports {
            ...surveyExportFragment
          }
        }
        ${fragments}
      `,
      subscribeToMore: {
        document: gql`
          subscription {
            onSurveyExport {
              ...surveyExportFragment
            }
          }
          ${fragments}
        `,
        updateQuery: (previous, { subscriptionData }) => {
          const surveyExports = [subscriptionData.data.onSurveyExport, ...previous.surveyExports];
          const result = { ...previous, surveyExports };
          return result;
        },
      },
    },
  },
  computed: {
    currentlyVisible: {
      get() {
        return this.isVisible;
      },
      set(newValue) {
        this.$emit('onVisiblityChange', newValue);
      },
    },
  },
  methods: {
    title(str) {
      return str.replace('_', ' ').replace(/(^|\s)\S/g, t => t.toUpperCase());
    },
    handleCancel() {
      this.$emit('onVisibilityChange', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// SurveyExportViewDialog.vue?05385632